<div class="content-layout fullwidth-basic-normal-scroll">
  <treo-card class="auth-card fullscreen">
    <div class="form-container">
      <div class="form">
        <div class="title">Sign in</div>
        <treo-message
          *ngIf="message"
          [appearance]="message.appearance"
          [showIcon]="message.showIcon"
          [type]="message.type"
          [@shake]="message.shake"
          data-cy="login-message"
        >
          {{ message.content }}
        </treo-message>
        <form [formGroup]="signInForm">
          <mat-form-field>
            <mat-label>Email Address</mat-label>
            <input id="email" matInput autofocus tabindex="1" [formControlName]="'email'" data-cy="email" />
          </mat-form-field>
          @if (hasRetrievedAuthenticationSettings && canLoginWithPassword) {
            <mat-form-field>
              <mat-label>Password</mat-label>
              <input
                id="password"
                matInput
                type="password"
                tabindex="2"
                [formControlName]="'password'"
                #passwordField
                data-cy="password"
              />
              <button mat-icon-button type="button" (click)="togglePasswordVisibility()" tabindex="-1" matSuffix>
                <mat-icon [svgIcon]="passwordFieldIcon"></mat-icon>
              </button>
            </mat-form-field>
            <div class="field-footer">
              <div></div>
              <a class="link" [routerLink]="['/forgot-password']">Forgot password?</a>
            </div>
            <button
              class="submit-button treo-mat-button-large"
              id="login-button"
              mat-flat-button
              type="submit"
              [color]="'primary'"
              tabindex="3"
              [disabled]="signInForm.disabled"
              (click)="signIn()"
              data-cy="login-button"
            >
              <span *ngIf="!signInForm.disabled"> Sign In </span>
              <mat-progress-spinner
                *ngIf="signInForm.disabled"
                [diameter]="24"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
            </button>
          }
          @if (hasRetrievedAuthenticationSettings && canLoginWithSaml) {
            <a [href]="ssoLoginUrl">
              <button mat-button class="w-full my-2" mat-stroked-button type="button">
                <span>Login with SSO</span>
              </button>
            </a>
            <button
              mat-button
              class="w-full my-2"
              mat-stroked-button
              type="button"
              (click)="clearAuthenticationSettings()"
            >
              <span><-- Back</span>
            </button>
          }
          @if (!hasRetrievedAuthenticationSettings) {
            <button
              class="submit-button treo-mat-button-large"
              mat-flat-button
              [color]="'primary'"
              tabindex="3"
              (click)="retrieveAuthenticationSettings()"
              data-cy="authentication-settings-button"
            >
              <span> Next </span>
            </button>
          }
        </form>
      </div>
    </div>
    <div class="content-container">
      <svg
        class="background"
        viewBox="0 0 1531 891"
        preserveAspectRatio="xMidYMax slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 182c144.327 47.973 534.462 219.712 440.509 369.87C346.555 702.028 79.877 662.846 0 638V182z"></path>
        <path
          d="M1405 848c-424.366 158.009-437-164-437-272s102-425 563-576v769c-21.333 29.333-63.333 55.667-126 79z"
        ></path>
        <path
          d="M1531 162c-122.914-17.284-377.96 33.191-543.433 206.414C822.095 541.636 797.342 648.75 835.842 731.622c38.5 82.871 198.243 134.841 400.555 92.053C1438.71 780.886 1492.752 775.894 1531 768V162z"
        ></path>
      </svg>

      <div class="content">
        <div class="title">
          <span>We make real estate</span>
          <span>investors better.</span>
        </div>
        <div class="description">
          TermSheet is a real estate workflow platform that brings your deals and data into a single location across
          both web and mobile.
        </div>
        <button class="learn-more-button" (click)="goHome()" type="button" mat-stroked-button>Learn more</button>
      </div>
    </div>
  </treo-card>
</div>
